export const ContactDetails = {
  email: 'an@facadeleads.com',
  phone: '(949) 838-5889',
  phoneHref: 'tel:+19498385889',
  hours: 'Monday to Friday, 8 am to 6 pm PST',
};